import React from 'react';
import { componentService } from 'js/services/component.service';

export const W2GReportingForm = React.lazy(() => import(/* webpackChunkName: "w2g-reporting-form" */ './W2GReportingForm'));

// <hub2-w2g-reporting-form></hub2-w2g-reporting-form>
componentService.registerWebContentComponents({ W2GReportingForm });
componentService.registerPageComponents({ 'w2g-reporting-form': W2GReportingForm });
